module.exports = __webpack_public_path__ + "static/media/lingmingshan_web.ad71b870.webp";